
const Projects = [
  {
    name: "word search",
    category: "portfolio",
    description: "Search a word",
    photo: require("../../assets/images/projects/wordDay.png"),
    link: "https://ann760.github.io/word-web/",
    git: "https://github.com/ann760/word_web"
  },
  {
    name: "my food choice",
    category: "portfolio",
    description: "submit food allergies and favorite foods",
    photo: require("../../assets/images/projects/food.png"),
    link: "https://food-67923.herokuapp.com/login",
    git: "https://github.com/ann760/my-food-choices"
  },
  {
    name: "media store",
    category: "portfolio",
    description: "Media-store",
    photo: require("../../assets/images/projects/media.png"),
    link: "https://floating-badlands-78581.herokuapp.com/",
    git: "https://github.com/ann760/media-store"
  },
  {
    name: "code quiz",
    category: "portfolio",
    description: "css heart",
    photo: require("../../assets/images/projects/quiz.png"),
    link: "https://ann760.github.io/code-quiz/",
    git: "https://github.com/ann760/code-quiz"
  },
  {
    name: "tech blog",
    category: "portfolio",
    description: "tech blog",
    photo: require("../../assets/images/projects/blog.png"),
    link: "https://peaceful-garden-31793.herokuapp.com/",
    git: "https://github.com/ann760/tech-blog"
  },
  {
    name: "budget",
    category: "portfolio",
    description: "budget",
    photo: require("../../assets/images/projects/budget.png"),
    link: "https://budget-76695.herokuapp.com/",
    git: "https://github.com/ann760/budget-tracker-pwa"
  },
  {
    name: "css heart",
    category: "portfolio",
    description: "css heart",
    photo: require("../../assets/images/projects/heart.png"),
    link: "https://codepen.io/ann760/details/vVWbVQ",
    git: ""
  },
];

export default Projects;
